import _ from 'lodash';
import { FlexibleObj } from '../interfaces/FlexibleObj';
import { Product } from './Product';

const NO_RATING = '0';
const ULTRA = '1';
const SELECT = '2';
const STANDARD = '3';
const SELECT_TOBACCO = '4';
const STANDARD_TOBACCO = '5';
const BEST = '6';
const BETTER = '7';
const AVERAGE = '8';
const TOBACCO = '9';
const NON_TOBACCO_PLUS = '10';
const TABLE_A = '60.101';
const TABLE_B = '60.102';
const TABLE_C = '60.103';
const TABLE_D = '60.104';
const TABLE_E = '60.105';
const TABLE_F = '60.106';
const TABLE_G = '60.107';
const TABLE_H = '60.108';
const TABLE_I = '60.109';
const TABLE_J = '60.110';
const TABLE_K = '60.111';
const TABLE_L = '60.112';
const TABLE_M = '60.113';
const TABLE_N = '60.114';
const TABLE_O = '60.115';
const TABLE_P = '60.116';
const TABLE_A_TOBACCO = '70.101';
const TABLE_B_TOBACCO = '70.102';
const TABLE_C_TOBACCO = '70.103';
const TABLE_D_TOBACCO = '70.104';
const TABLE_E_TOBACCO = '70.105';
const TABLE_F_TOBACCO = '70.106';
const TABLE_G_TOBACCO = '70.107';
const TABLE_H_TOBACCO = '70.108';
const TABLE_I_TOBACCO = '70.109';
const TABLE_J_TOBACCO = '70.110';
const TABLE_K_TOBACCO = '70.111';
const TABLE_L_TOBACCO = '70.112';
const TABLE_M_TOBACCO = '70.113';
const TABLE_N_TOBACCO = '70.114';
const TABLE_O_TOBACCO = '70.115';
const TABLE_P_TOBACCO = '70.116';
const BY_PASS_KNOCKOUT = '90';
const KNOCKOUT = '99';
const DECLINE_WITH_VANTAGE = '998';
const DECLINE = '999';
const REJECT_WITH_HAVEN = '9997';
const REJECT_WITH_VANTAGE = '9998';
const REJECT = '9999';

export type RateClassObj = {
  code: string;
  stringCode: string;
  name: string;
  desc: string;
  abbr: string;
  smoker?: boolean;
  ignoringSmokerCode?: string;
  smokerCode: string;
  qCode?: string;
};

export const RateClasses = {
  NO_RATING: {
    code: NO_RATING,
    stringCode: 'NO_RATING',
    name: 'No Rating',
    desc: 'No Rating',
    abbr: '-',
    smokerCode: NO_RATING,
    qCode: '',
  },
  ULTRA: {
    code: ULTRA,
    stringCode: 'ULTRA',
    name: 'Ultra-Preferred',
    desc: 'Ultra-Preferred (Non-Smoker)',
    abbr: 'UPNT',
    smoker: false,
    ignoringSmokerCode: ULTRA,
    smokerCode: SELECT_TOBACCO,
    qCode: 'P+',
  },
  SELECT: {
    code: SELECT,
    stringCode: 'SELECT',
    name: 'Select-Preferred',
    desc: 'Select-Preferred (Non-Smoker)',
    abbr: 'SPNT',
    smoker: false,
    ignoringSmokerCode: SELECT,
    smokerCode: SELECT_TOBACCO,
    qCode: 'Pf',
  },
  STANDARD: {
    code: STANDARD,
    stringCode: 'STANDARD',
    name: 'Standard',
    desc: 'Standard (Non-Smoker)',
    abbr: 'NT',
    smoker: false,
    ignoringSmokerCode: STANDARD,
    smokerCode: STANDARD_TOBACCO,
    qCode: 'R+',
  },
  SELECT_TOBACCO: {
    code: SELECT_TOBACCO,
    stringCode: 'SELECT_TOBACCO',
    name: 'Select-Preferred',
    desc: 'Select-Preferred (Smoker)',
    abbr: 'SPT',
    smoker: true,
    ignoringSmokerCode: SELECT,
    smokerCode: SELECT_TOBACCO,
    qCode: 'Pf',
  },
  STANDARD_TOBACCO: {
    code: STANDARD_TOBACCO,
    stringCode: 'STANDARD_TOBACCO',
    name: 'Standard',
    desc: 'Standard (Smoker)',
    abbr: 'T',
    smoker: true,
    ignoringSmokerCode: STANDARD,
    smokerCode: STANDARD_TOBACCO,
    qCode: 'R+',
  },
  BEST: {
    code: BEST,
    stringCode: 'BEST',
    desc: 'Best',
    abbr: '-',
    smoker: false,
    ignoringSmokerCode: BEST,
    smokerCode: TOBACCO,
    qCode: 'UNUSED',
  },
  BETTER: {
    code: BETTER,
    stringCode: 'BETTER',
    desc: 'BETTER',
    abbr: '-',
    smoker: false,
    ignoringSmokerCode: BETTER,
    smokerCode: TOBACCO,
    qCode: 'UNUSED',
  },
  AVERAGE: {
    code: AVERAGE,
    stringCode: 'AVERAGE',
    desc: 'AVERAGE',
    abbr: '-',
    smoker: false,
    ignoringSmokerCode: AVERAGE,
    smokerCode: TOBACCO,
    qCode: 'UNUSED',
  },
  TOBACCO: {
    code: TOBACCO,
    stringCode: 'TOBACCO',
    desc: 'TOBACCO',
    abbr: '-',
    smoker: true,
    ignoringSmokerCode: TOBACCO,
    smokerCode: TOBACCO,
    qCode: 'UNUSED',
  },
  NON_TOBACCO_PLUS: {
    code: NON_TOBACCO_PLUS,
    stringCode: 'NON_TOBACCO_PLUS',
    desc: 'Non-Tobacco Plus',
    abbr: '-',
    smoker: false,
    ignoringSmokerCode: NON_TOBACCO_PLUS,
    smokerCode: NON_TOBACCO_PLUS,
    qCode: 'UNUSED',
  },
  TABLE_B: {
    code: TABLE_B,
    stringCode: 'TABLE_B',
    name: 'Substandard',
    desc: 'TABLE B (Non-Smoker)',
    abbr: 'TABLE B NT',
    smoker: false,
    ignoringSmokerCode: TABLE_B,
    smokerCode: TABLE_B_TOBACCO,
  },
  TABLE_C: {
    code: TABLE_C,
    stringCode: 'TABLE_C',
    name: 'Substandard',
    desc: 'TABLE C (Non-Smoker)',
    abbr: 'TABLE C NT',
    smoker: false,
    ignoringSmokerCode: TABLE_C,
    smokerCode: TABLE_C_TOBACCO,
  },
  TABLE_D: {
    code: TABLE_D,
    stringCode: 'TABLE_D',
    name: 'Substandard',
    desc: 'TABLE D (Non-Smoker)',
    abbr: 'TABLE D NT',
    smoker: false,
    ignoringSmokerCode: TABLE_D,
    smokerCode: TABLE_D_TOBACCO,
  },
  TABLE_E: {
    code: TABLE_E,
    stringCode: 'TABLE_E',
    name: 'Substandard',
    desc: 'TABLE E (Non-Smoker)',
    abbr: 'TABLE E NT',
    smoker: false,
    ignoringSmokerCode: TABLE_E,
    smokerCode: TABLE_E_TOBACCO,
  },
  TABLE_F: {
    code: TABLE_F,
    stringCode: 'TABLE_F',
    name: 'Substandard',
    desc: 'TABLE F (Non-Smoker)',
    abbr: 'TABLE F NT',
    smoker: false,
    ignoringSmokerCode: TABLE_F,
    smokerCode: TABLE_F_TOBACCO,
  },
  TABLE_H: {
    code: TABLE_H,
    stringCode: 'TABLE_H',
    name: 'Substandard',
    desc: 'TABLE H (Non-Smoker)',
    abbr: 'TABLE H NT',
    smoker: false,
    ignoringSmokerCode: TABLE_H,
    smokerCode: TABLE_H_TOBACCO,
  },
  TABLE_J: {
    code: TABLE_J,
    stringCode: 'TABLE_J',
    name: 'Substandard',
    desc: 'TABLE J (Non-Smoker)',
    abbr: 'TABLE J NT',
    smoker: false,
    ignoringSmokerCode: TABLE_J,
    smokerCode: TABLE_J_TOBACCO,
  },
  TABLE_L: {
    code: TABLE_L,
    stringCode: 'TABLE_L',
    name: 'Substandard',
    desc: 'TABLE L (Non-Smoker)',
    abbr: 'TABLE L NT',
    smoker: false,
    ignoringSmokerCode: TABLE_L,
    smokerCode: TABLE_L_TOBACCO,
  },
  TABLE_P: {
    code: TABLE_P,
    stringCode: 'TABLE_P',
    name: 'Substandard',
    desc: 'TABLE P (Non-Smoker)',
    abbr: 'TABLE P NT',
    smoker: false,
    ignoringSmokerCode: TABLE_P,
    smokerCode: TABLE_P_TOBACCO,
  },
  TABLE_B_TOBACCO: {
    code: TABLE_B_TOBACCO,
    stringCode: 'TABLE_B_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE B (Smoker)',
    abbr: 'TABLE B T',
    smoker: true,
    ignoringSmokerCode: TABLE_B,
    smokerCode: TABLE_B_TOBACCO,
  },
  TABLE_C_TOBACCO: {
    code: TABLE_C_TOBACCO,
    stringCode: 'TABLE_C_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE C (Smoker)',
    abbr: 'TABLE C T',
    smoker: true,
    ignoringSmokerCode: TABLE_C,
    smokerCode: TABLE_C_TOBACCO,
  },
  TABLE_D_TOBACCO: {
    code: TABLE_D_TOBACCO,
    stringCode: 'TABLE_D_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE D (Smoker)',
    abbr: 'TABLE D T',
    smoker: true,
    ignoringSmokerCode: TABLE_D,
    smokerCode: TABLE_D_TOBACCO,
  },
  TABLE_E_TOBACCO: {
    code: TABLE_E_TOBACCO,
    stringCode: 'TABLE_E_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE E (Smoker)',
    abbr: 'TABLE E T',
    smoker: true,
    ignoringSmokerCode: TABLE_E,
    smokerCode: TABLE_E_TOBACCO,
  },
  TABLE_F_TOBACCO: {
    code: TABLE_F_TOBACCO,
    stringCode: 'TABLE_F_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE F (Smoker)',
    abbr: 'TABLE F T',
    smoker: true,
    ignoringSmokerCode: TABLE_F,
    smokerCode: TABLE_F_TOBACCO,
  },
  TABLE_H_TOBACCO: {
    code: TABLE_H_TOBACCO,
    stringCode: 'TABLE_H_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE H (Smoker)',
    abbr: 'TABLE H T',
    smoker: true,
    ignoringSmokerCode: TABLE_H,
    smokerCode: TABLE_H_TOBACCO,
  },
  TABLE_J_TOBACCO: {
    code: TABLE_J_TOBACCO,
    stringCode: 'TABLE_J_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE J (Smoker)',
    abbr: 'TABLE J T',
    smoker: true,
    ignoringSmokerCode: TABLE_J,
    smokerCode: TABLE_J_TOBACCO,
  },
  TABLE_L_TOBACCO: {
    code: TABLE_L_TOBACCO,
    stringCode: 'TABLE_L_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE L (Smoker)',
    abbr: 'TABLE L T',
    smoker: true,
    ignoringSmokerCode: TABLE_L,
    smokerCode: TABLE_L_TOBACCO,
  },
  TABLE_P_TOBACCO: {
    code: TABLE_P_TOBACCO,
    stringCode: 'TABLE_P_TOBACCO',
    name: 'Substandard',
    desc: 'TABLE P (Smoker)',
    abbr: 'TABLE P T',
    smoker: true,
    ignoringSmokerCode: TABLE_P,
    smokerCode: TABLE_P_TOBACCO,
  },
  BY_PASS_KNOCKOUT: {
    code: BY_PASS_KNOCKOUT,
    stringCode: 'BY_PASS_KNOCKOUT',
    name: 'By Pass Knocked Out',
    desc: 'By Pass Knocked Out',
    abbr: '-',
    smokerCode: BY_PASS_KNOCKOUT,
    qCode: '',
  },
  KNOCKOUT: {
    code: KNOCKOUT,
    stringCode: 'KNOCKOUT',
    name: 'Knocked Out',
    desc: 'Knocked Out',
    abbr: '-',
    smokerCode: KNOCKOUT,
    qCode: '',
  },
  DECLINE_WITH_VANTAGE: {
    code: DECLINE_WITH_VANTAGE,
    stringCode: 'DECLINE_WITH_VANTAGE',
    name: 'Declined',
    desc: 'Declined (Ratable)',
    abbr: 'DECLINE',
    smokerCode: DECLINE_WITH_VANTAGE,
    qCode: '',
  },
  DECLINE: {
    code: DECLINE,
    stringCode: 'DECLINE',
    name: 'Declined',
    desc: 'Declined (Uninsurable)',
    abbr: 'DECLINE',
    smokerCode: DECLINE,
    qCode: '',
  },
  REJECT_WITH_HAVEN: {
    code: REJECT_WITH_HAVEN,
    stringCode: 'REJECT_WITH_HAVEN',
    name: 'Rejected',
    desc: 'Rejected (with Haven option)',
    abbr: 'REJECT',
    smokerCode: REJECT_WITH_HAVEN,
    qCode: '',
  },
  REJECT_WITH_VANTAGE: {
    code: REJECT_WITH_VANTAGE,
    stringCode: 'REJECT_WITH_VANTAGE',
    name: 'Rejected',
    desc: 'Rejected (with Vantage option)',
    abbr: 'REJECT',
    smokerCode: REJECT_WITH_VANTAGE,
    qCode: '',
  },
  REJECT: {
    code: REJECT,
    stringCode: 'REJECT',
    name: 'Rejected',
    desc: 'Rejected',
    abbr: 'REJECT',
    smokerCode: REJECT,
    qCode: '',
  },
  find(code: string): RateClassObj {
    const matcher = {
      code: code,
    };
    return this._findMatch(matcher);
  },
  findByQCode(qCode: string): RateClassObj {
    const matcher = {
      qCode: qCode,
    };

    return this._findMatch(matcher);
  },
  findByStringCode(stringCode: string): RateClassObj {
    const matcher = {
      stringCode: stringCode,
    };
    return this._findMatch(matcher);
  },
  _findMatch(matcher: FlexibleObj<string | boolean>): RateClassObj {
    const found = _.find(_.values(this), matcher);
    return found || { desc: 'N/A' };
  },
  isRated(rateClass: string): boolean {
    const rating = this.find(rateClass);

    const compareFn = (ratingCode: string) =>
      Number(ULTRA) <= Number(ratingCode) && Number(ratingCode) <= Number(STANDARD_TOBACCO);

    return !!rating && !!rating.code && compareFn(rating.code);
  },
  isTableRated(rateClass: string): boolean {
    const rating = this.find(rateClass);
    return (
      !!rating &&
      !!rating.code &&
      Number(TABLE_B) <= Number(rating.code) &&
      Number(rating.code) <= Number(TABLE_P_TOBACCO)
    );
  },
  isTableRatedByStringCode(rateClass: string): boolean {
    const rating = this.findByStringCode(rateClass);
    return (
      !!rating &&
      !!rating.code &&
      Number(TABLE_B) <= Number(rating.code) &&
      Number(rating.code) <= Number(TABLE_P_TOBACCO)
    );
  },
  /**
   * Compare two rate classes
   * The caller needs to make sure both rateClass1 and rateClass2 are valid rateClass which has valid code
   * @param rateClass1
   * @param rateClass2
   * If returns negative, rateClass1 is better than rateClass2. E.g., ULTRA is better than SELECT
   * If returns 0, rateClass1 is same as rateClass2 OR one class has no rating and is thus incomparable
   * If returns positive, rateClass1 is worse than rateClass2
   */
  compare(rateClass1: string, rateClass2: string): number {
    const rating1 = Number(this.find(rateClass1).code);
    const rating2 = Number(this.find(rateClass2).code);
    if (rating1 === 0 || rating2 === 0) {
      return 0;
    }
    return rating1 - rating2;
  },
  isDecline(rateClass: string): boolean {
    const rating = this.find(rateClass);
    return [this.DECLINE_WITH_VANTAGE.code, this.DECLINE.code].indexOf(rating.code) > -1;
  },
  isRejected(rateClass: string): boolean {
    const rating = this.find(rateClass);
    return [this.REJECT_WITH_HAVEN.code, this.REJECT_WITH_VANTAGE.code, this.REJECT.code].indexOf(rating.code) > -1;
  },
};

// Deprecated health class, only available for migrated MMTRADTerm policies
export const NonTobaccoPlus = {
  rateCode: '10',
  stringCode: 'NON_TOBACCO_PLUS',
  rateClassDescription: {
    shortDescription: 'Non-Tobacco Plus',
    longDescription: 'Non-Tobacco Plus',
    healthClassNumber: 10,
    tobaccoDescription: 'Non-Tobacco Plus',
  },
};
